/**
 * Copy and hrefs for the chrome shared by every public page (TopNav, Footer).
 *
 * Page-specific copy stays in that page's own constants.ts — this file is only
 * for values more than one public page renders.
 */
import type { FooterLink, NavLink } from './types';

import { BOOK_A_CALL_HREF } from '@/shared/constants';
import { LEGAL_ROUTES, LOGIN_ROUTES, PUBLIC_ROUTES } from '@/shared/routes/paths';

export const AUTH_HREF: string = LOGIN_ROUTES.ROOT;
// Re-exported from shared/ so shared code can depend on it without importing a
// page module; public pages keep importing it from here.
export { BOOK_A_CALL_HREF };

/**
 * Absolute rather than bare `#engage`: the nav renders on /contact too, where a
 * bare fragment would resolve against the wrong document and do nothing.
 */
export const NAV_LINKS: NavLink[] = [
  { href: '/#engage', label: 'Get started' },
  { href: '/#solutions', label: 'Solutions' },
  { href: '/#faq', label: 'FAQ' }
];

export const FOOTER_LINKS: FooterLink[] = [
  { label: 'Contact Us', href: PUBLIC_ROUTES.CONTACT },
  // Internal, portal-owned pages, routed in-app rather than opened in a new
  // tab. These used to force `newTab` so a reader wouldn't lose their place —
  // but every /legal page now carries the policy rail, so the way back is on
  // the page itself, and spawning a tab per policy link only litters the tab
  // bar of anyone comparing two of them.
  { label: 'Privacy', href: LEGAL_ROUTES.PRIVACY },
  { label: 'Terms of Use', href: LEGAL_ROUTES.TERMS_OF_USE },
  // Persistent CPRA control. A real page rather than reopening the consent
  // banner in place, so the choice has a shareable, bookmarkable URL.
  { label: 'Your Privacy Choices', href: LEGAL_ROUTES.PRIVACY_CHOICES }
];

export const FOOTER_COPYRIGHT = '© ThredUp Inc. All Rights Reserved';
